import { CalendarDays, Lock } from "lucide-react";

const PROGRAMS = [
  { title: "Mesyuarat Agung Tahunan PPPS 2026", date: "15 Mac 2026" },
  { title: "Taklimat Pematuhan & Kesedaran Risiko", date: "22 April 2026" },
  { title: "Sesi Latihan Pengiring Rapat & Kesiapsiagaan", date: "10 Jun 2026" },
];

export default function ProgramMember() {
  return (
    <div className="p-6 sm:p-10 max-w-2xl" data-testid="member-program-page">
      <h1 className="font-display text-xl font-bold text-piks-black mb-6">Program</h1>
      <div className="space-y-3 mb-6">
        {PROGRAMS.map((p) => (
          <div key={p.title} className="flex gap-4 p-4 rounded-lg bg-white border border-piks-border">
            <CalendarDays className="w-5 h-5 text-piks-red shrink-0 mt-0.5" />
            <div>
              <p className="text-xs text-piks-red font-semibold">{p.date}</p>
              <p className="text-sm font-medium text-piks-black">{p.title}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center gap-3 p-4 rounded-lg bg-piks-ivory border border-dashed border-piks-border text-piks-muted">
        <Lock className="w-4 h-4" />
        <p className="text-sm">Modul Latihan &amp; Pensijilan — Akan Datang</p>
      </div>
    </div>
  );
}
